import React from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import ProducerHero from '../../components/producer/ProducerHero';
import ProducerFeatures from '../../components/producer/ProducerFeatures';
import ProducerBridge from '../../components/producer/ProducerBridge';
import ProducerProcess from '../../components/producer/ProducerProcess';

const SejaProdutor = () => {
  return (
    <>
      <Header />
      <ProducerHero />
      <ProducerFeatures />
      <ProducerBridge />
      <ProducerProcess />
      <Footer />
    </>
  );
};

export default SejaProdutor;